import { formatDate } from '@angular/common';
import { COMPARE } from 'src/app/types/@types/comparisons';
import { Component, OnInit, HostBinding, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { DateWithinCountOfWhich, DateWithinValueComponent } from '../date-within-value/date-within-value.component';
import { mSecondsFromEpoch } from 'src/app/types/@types/sl-v-types';
import { SearchCriterion, CriterionEvent, ICriterionComponent, SearchCriteriaRegistrant } from 'src/app/types/search-criteria';
import { DateUtil } from 'src/app/model/dateutil';
import { DateOfValueComponent } from '../date-of-value/date-of-value.component';

export interface DateBuffer {
  bufferInfo: DateWithinCountOfWhich;
  targetDate: string;
}

@Component({
  selector: 'app-date-buffer',
  templateUrl: './date-buffer.component.html',
  styleUrls: ['./date-buffer.component.scss']
})
export class DateBufferComponent implements OnInit, ICriterionComponent {

  @Input()
  public field = '';

  @Output()
  public registrantReady = new EventEmitter<SearchCriteriaRegistrant>();

  @Input() comparison = '';

  @Output()
  public criteriaChange = new EventEmitter<CriterionEvent>();

  public defaultValue: DateBuffer = {
    bufferInfo: {
      count: 0,
      range: '',
      which: 'days'
    },
    targetDate: formatDate(new Date(),'yyyy-MM-dd','en')
  }
  public buffer: DateBuffer;

  @Output() valueChange: EventEmitter<DateBuffer> = new EventEmitter<DateBuffer>();

  @Input()
  public set value(buffer: DateBuffer | null) {
    if (!buffer) {
      buffer = JSON.parse(JSON.stringify(this.defaultValue));
    }
    this.buffer = buffer;
  }
  public get value(): DateBuffer {
    return {
      bufferInfo: this.dateWithinInputs.value,
      targetDate: this.dateOfInput.value
    }

  }
  @ViewChild('dateWithinInputs') dateWithinInputs: DateWithinValueComponent;
  @ViewChild('dateOfInput') dateOfInput: DateOfValueComponent;



  constructor() {

    this.value = null;
  }

  UpdateValue() {

    this.criteriaChange.emit({
      target: this,
      value: this.value,
      criterion: this.ToCriterion()
    });
    this.valueChange.emit(this.value);
  }

  ngOnInit(): void {
    this.registrantReady.emit({ field: this.field, component: this })
  }
  ToCriterion(field?: string, comparison?: any): SearchCriterion | null {
    if (!field) {
      field = this.field;
    }
    if (field === '') {
      return null;
    }

    return DateUtil.DateBufferToCriterion(field, this.value, comparison===COMPARE.DATE_NOT_BETWEEN);
  }

}
